{
  "en": {
    "account": {
      "build_your_profile": "Build your profile",
      "my_bookings": "My Experience Bookings",
      "my_orders": "My Orders",
      "my_registries": "My Gift Registries",
      "profile": "Profile",
      "profile_overview": "Profile Overview",
      "settings": "Settings"
    },
    "activemodel": {
      "attributes": {
        "checkout": {
          "billing_country_id": "Country",
          "billing_first_line": "Address line 1",
          "billing_first_name": "First name",
          "billing_last_name": "Last name",
          "billing_phone": "Phone",
          "billing_second_line": "Address line 2",
          "billing_state": "State / Province",
          "billing_zip_code": "ZIP code",
          "cart_delivery_different_to_billing_yes": "Different to billing address",
          "cart_delivery_same_as_billing_yes": "Same billing address",
          "shipping_country_id": "Country",
          "shipping_first_line": "Address line 1",
          "shipping_first_name": "First name",
          "shipping_last_name": "Last name",
          "shipping_phone": "Phone",
          "shipping_second_line": "Address line 2",
          "shipping_state": "State / Province",
          "shipping_zip_code": "ZIP code"
        }
      },
      "errors": {
        "models": {
          "checkout": {
            "attributes": {
              "billing_first_line": {
                "blank": "is required"
              },
              "billing_first_name": {
                "blank": "is required"
              },
              "billing_last_name": {
                "blank": "is required"
              },
              "billing_phone": {
                "blank": "is required"
              },
              "billing_state": {
                "blank": "is required"
              },
              "shipping_first_line": {
                "blank": "is required"
              },
              "shipping_first_name": {
                "blank": "is required"
              },
              "shipping_last_name": {
                "blank": "is required"
              },
              "shipping_phone": {
                "blank": "is required"
              },
              "shipping_state": {
                "blank": "is required"
              }
            }
          }
        }
      },
      "models": {
        "checkout": "Checkout"
      },
      "placeholders": {
        "checkout": {
          "billing_first_line": "Enter address line 1",
          "billing_first_name": "Enter first name",
          "billing_last_name": "Enter last name",
          "billing_phone": "Enter phone",
          "billing_second_line": "Enter address line 2",
          "billing_state": "Enter state / province",
          "billing_zip_code": "Enter zip code",
          "shipping_first_line": "Enter address line 1",
          "shipping_first_name": "Enter first name",
          "shipping_last_name": "Enter last name",
          "shipping_phone": "Enter phone",
          "shipping_second_line": "Enter address line 2",
          "shipping_state": "Enter state / province",
          "shipping_zip_code": "Enter zip code"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "address": {
          "apartment": "Edificio / Apartamento / Extensión",
          "contact_name": "Nombre de contacto",
          "contact_phone": "Teléfono",
          "contact_phone_mobile": "Teléfono móvil",
          "door": "Número de puerta",
          "name": "Alias",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "shipping_zone_id": "Ciudad",
          "street": "Calle"
        },
        "alliance_order": {
          "statuses": {
            "active": "Activo",
            "cancelled": "Cancelado",
            "invoiced": "Facturado"
          }
        },
        "bank_transfer_payment": {
          "voucher": "Comprobante"
        },
        "bucket_address": {
          "apartment": "Edificio / Apartamento / Extensión",
          "contact_name": "Nombre de contacto",
          "contact_phone": "Teléfono",
          "contact_phone_mobile": "Teléfono móvil",
          "door": "Número de puerta",
          "name": "Alias",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "shipping_zone_id": "Ciudad",
          "street": "Calle"
        },
        "category": {
          "body": "Descripción",
          "description": "Descripción (SEO)",
          "image": "Imagen",
          "name": "Nombre",
          "parent": "Categoría madre",
          "parent_id": "Categoría madre",
          "statuses": {
            "active": "Activa",
            "inactive": "Inactiva"
          }
        },
        "credit_line_request": {
          "bank_ref_one_account": "No. Cuenta 1",
          "bank_ref_one_branch": "Sucursal 1",
          "bank_ref_one_name": "Banco 1",
          "bank_ref_one_phone": "Tel 1",
          "bank_ref_three_account": "No. cuenta 3",
          "bank_ref_three_branch": "Sucursal 3",
          "bank_ref_three_name": "Banco 3",
          "bank_ref_three_phone": "Tel 3",
          "bank_ref_two_account": "No. Cuenta 2",
          "bank_ref_two_branch": "Sucursal 2",
          "bank_ref_two_name": "Banco 2",
          "bank_ref_two_phone": "Tel 2",
          "finances_email": "Email",
          "finances_ext": "Ext.",
          "finances_manager_name": "Nombre del gerente financiero",
          "finances_phone": "Teléfono",
          "has_second_branch": "Tiene la empresa otra sucursal?",
          "last_day_to_invoices": "Última fecha para recibir facturas",
          "owner_id": "No. Documento de identidad personal",
          "owner_identification": "No. Documento de identidad personal",
          "owner_name": "Nombre del propiertario o gerente general",
          "owner_nationality": "Nacionalidad",
          "owner_phone": "Teléfono Móvil",
          "owner_residential_phone": "Teléfono residencial",
          "payment_method_bank_transfer": "transferencia bancaria",
          "payment_method_cash": "Efectivo",
          "payment_method_cc": "Tarjeta crédito/débito *",
          "purchasing_manager_email": "Email",
          "purchasing_manager_ext": "Ext",
          "purchasing_manager_name": "Nombre del encargado",
          "purchasing_manager_phone": "Teléfono",
          "purchasing_sub_manager_email": "Email",
          "purchasing_sub_manager_ext": "Ext",
          "purchasing_sub_manager_name": "Nombre del sub-encargado",
          "purchasing_sub_manager_phone": "Teléfono",
          "ref_one_company_name": "Empresa 1",
          "ref_one_contact_name": "Contacto 1",
          "ref_one_phone": "Teléfono 1",
          "ref_three_company_name": "Empresa 3",
          "ref_three_contact_name": "Contacto 3",
          "ref_three_phone": "Teléfono 3",
          "ref_two_company_name": "Empresa 2",
          "ref_two_contact_name": "Contacto 2",
          "ref_two_phone": " Teléfono 2",
          "requested_amount": "Monto del crédito solicitado",
          "second_branch_address": "Dirección",
          "second_branch_city": "Ciudad",
          "second_branch_email": "Email",
          "second_branch_fax": "Fax",
          "second_branch_phone": "Teléfono",
          "second_branch_principal_name": "Contacto principal",
          "statuses": {
            "approved": "Arpobado",
            "declined": "Declinado",
            "pending": "Pendiente"
          },
          "time_in_market": "Tiempo en el mercado"
        },
        "discount": {
          "kind": "Tipo",
          "kinds": {
            "amount": "Monto ($RD)",
            "percentage": "Porcentaje"
          },
          "name": "Nombre",
          "status": "Estado",
          "statuses": {
            "active": "Activo",
            "inactive": "Inactivo"
          },
          "value": "Valor"
        },
        "discountable_discount": {
          "discount_id": "Descuento"
        },
        "document": {
          "description": "Descripción",
          "name": "Nombre"
        },
        "experience": {
          "statuses": {
            "published": "Published",
            "unpublished": "Unpublished"
          }
        },
        "order": {
          "invoice_voucher_kinds": {
            "final_consumer": "Consumidor final",
            "fiscal_credit": "Crédito fiscal",
            "governmental": "Gubernamental",
            "special_regimes": "Regímenes especiales"
          },
          "statuses": {
            "authorized": "Autorizada",
            "fraudulent": "Fraude",
            "paid": "Pagada",
            "partially_paid": "Pago parcial",
            "partially_refunded": "Reembolso parcial",
            "pending": "Incompleta",
            "refunded": "Reembolsada",
            "unpaid": "Sin pagar",
            "voided": "Anulada"
          }
        },
        "package": {
          "statuses": {
            "canceled": "Cancelado",
            "completed": "Completado",
            "in_preparation": "Preparando",
            "pending": "Pendiente",
            "picked_up": "Recogido",
            "ready_for_pickup": "Listo para entrega"
          }
        },
        "payment": {
          "amount": "Monto",
          "note": "Nota",
          "statuses": {
            "cancelled": "Cancelado",
            "completed": "Completado",
            "pending": "Pendiente",
            "refunded": "Reembolzado",
            "unpaid": "Sin pagar",
            "voided": "Evitado"
          }
        },
        "post": {
          "body": "Cuerpo",
          "cover": "Portada",
          "cover_alt": "Alt de portada",
          "description": "Descripción",
          "name": "Nombre",
          "post_category": "Categoría",
          "published_at": "Publicado el",
          "status": "Estado",
          "statuses": {
            "archived": "Archivado",
            "published": "Publicado",
            "unpublished": "Sin publicar"
          }
        },
        "product": {
          "description": "Dice el fabricante",
          "discounted_price": "Precio con Descuento",
          "dp_id": "ID externo",
          "dp_margin_percentage": "Margen min deseado (%)",
          "dp_price": "Precio externo",
          "dp_vendor": "Plataforma externa",
          "dp_vendors": {
            "interfacedo": "Interface S.A.",
            "none": "Ninguna",
            "omega_tech": "Omega Tech",
            "pricesmart": "Pricesmart"
          },
          "featured_image": "Imagen destacada",
          "name": "Nombre",
          "price": "Precio",
          "quantity_per_box": "Cnt. por caja",
          "shipping_package": "Empacado",
          "shipping_packages": {
            "automatic": "Auto",
            "big": "Grande",
            "medium": "Mediano",
            "pallet": "Paleta",
            "small": "Estándar"
          },
          "short_description": "Descripción corta",
          "status": "Estado",
          "statuses": {
            "archived": "Archived",
            "published": "Published",
            "unpublished": "Unpublished"
          },
          "warehouse_location": "Ubicación en almacén"
        },
        "shipment": {
          "statuses": {
            "fulfilled": "Entregado",
            "partially_fulfilled": "Articulos pendientes",
            "scheduled": "Agendado",
            "unfulfilled": "Sin preparar"
          }
        },
        "shipping_zone": {
          "kind": "Zona",
          "name": "Nombre"
        },
        "system_setting": {
          "hero_one_img": "Imagen del primer espacio del hero",
          "hero_one_url": "Enlace del primer espacio del hero",
          "hero_three_img": "Imagen del tercer espacio del hero",
          "hero_three_url": "Enlace del tercer espacio del hero",
          "hero_two_img": "Imagen del segundo espacio del hero",
          "hero_two_url": "Enlace del segundo espacio del hero",
          "last_banner_img": "Imagen del último banner (Home)",
          "last_banner_url": "Enlace del último banner (Home)",
          "middle_banner_img": "Imagen del banner en el medio (Home)",
          "middle_banner_url": "Enlace del banner en el medio (Home)"
        },
        "user": {
          "current_password": "Contraseña actual",
          "email": "Correo electrónico",
          "first_name": "Nombre",
          "last_name": "Apellido",
          "name": "Nombre completo",
          "password": "Contraseña",
          "password_confirmation": "Repetir contraseña",
          "phone": "Teléfono",
          "remember_me": "Permanecer conectado",
          "roles": {
            "admin": "Admin",
            "customer": "Cliente"
          }
        },
        "warehouse": {
          "address": "Dirección",
          "bucket_id": "Proveedor",
          "dropshipping": "Dropshipping",
          "name": "Nombre",
          "statuses": {
            "published": "Publicado",
            "unpublished": "Sin publicar"
          },
          "with_delivery": "Delivery",
          "with_pick_up": "Pickup"
        },
        "whats_app_representative": {
          "name": "Nombre",
          "phone": "Número de WhatsApp",
          "statuses": {
            "active": "Activo",
            "inactive": "Inactivo"
          }
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        },
        "models": {
          "address": {
            "attributes": {
              "apartment": {
                "blank": "%{attribute} es obligatorio"
              },
              "contact_name": {
                "blank": "%{attribute} es obligatorio"
              },
              "contact_phone": {
                "invalid": "%{attribute} no es valido"
              },
              "contact_phone_mobile": {
                "invalid": "%{attribute} no es valido"
              },
              "door": {
                "blank": "%{attribute} es obligatorio"
              },
              "name": {
                "blank": "%{attribute} es obligatorio"
              },
              "sector": {
                "blank": "%{attribute} es obligatorio"
              },
              "shipping_zone": {
                "required": "es obligatorio"
              },
              "street": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "bank_transfer_payment": {
            "attributes": {
              "voucher": {
                "blank": "debes adjuntar el comprobante"
              }
            }
          },
          "bucket": {
            "attributes": {
              "address": {
                "blank": "es obligatorio"
              },
              "alli_code": {
                "taken": "no está disponible"
              },
              "contact_name": {
                "blank": "es obligatorio"
              },
              "contact_phone": {
                "blank": "es obligatorio"
              },
              "name": {
                "blank": "es obligatorio"
              },
              "rnc": {
                "blank": "es obligatorio"
              }
            }
          },
          "bucket_address": {
            "attributes": {
              "apartment": {
                "blank": "%{attribute} es obligatorio"
              },
              "contact_phone": {
                "invalid": "%{attribute} no es valido"
              },
              "contact_phone_mobile": {
                "invalid": "%{attribute} no es valido"
              },
              "door": {
                "blank": "%{attribute} es obligatorio"
              },
              "first_name": {
                "blank": "%{attribute} es obligatorio"
              },
              "name": {
                "blank": "%{attribute} es obligatorio"
              },
              "sector": {
                "blank": "%{attribute} es obligatorio"
              },
              "shipping_zone": {
                "required": "es obligatorio"
              },
              "street": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "catalog": {
            "attributes": {
              "file": {
                "blank": "es obligatorio"
              },
              "name": {
                "blank": "es obligatorio"
              }
            }
          },
          "discount": {
            "attributes": {
              "delivery_method": {
                "taken": "ya esta en uso"
              },
              "name": {
                "blank": "es obligatorio"
              }
            }
          },
          "discountable_discount": {
            "attributes": {
              "discount": {
                "required": "es obligatorio"
              }
            }
          },
          "document": {
            "attributes": {
              "name": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "estimate": {
            "attributes": {
              "address_id": {
                "required": "es obligatorio"
              }
            }
          },
          "join_bucket": {
            "attributes": {
              "code": {
                "blank": "%{attribute} es obligatorio"
              },
              "id": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "order": {
            "attributes": {
              "address_id": {
                "blank": "donde deseas recibir tu pedido"
              },
              "delivery_method": {
                "blank": "elige un método de entrega"
              },
              "invoice_identification": {
                "blank": "es obligatorio"
              },
              "invoice_name": {
                "blank": "es obligatorio"
              },
              "invoice_voucher_kind": {
                "blank": "es obligatorio"
              },
              "warehouse_id": {
                "blank": "donde deseas buscar tu pedido"
              }
            }
          },
          "payment_transfer": {
            "attributes": {
              "voucher": {
                "blank": "%{attribute} es obligatorio"
              }
            }
          },
          "user": {
            "attributes": {
              "current_password": {
                "blank": "%{attribute} es obligatoria",
                "invalid": "%{attribute} es invalida"
              },
              "email": {
                "blank": "%{attribute} es obligatorio",
                "taken": "ya esta en uso",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "first_name": {
                "blank": "%{attribute} es obligatorio",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "name": {
                "blank": "%{attribute} es obligatorio",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "password": {
                "blank": "%{attribute} es obligatoria",
                "too_long": "Debe tener %{count} caracteres máximo",
                "too_short": "Debe tener %{count} caracteres mínimo"
              },
              "password_confirmation": {
                "confirmation": "Debe ser igual que tu contraseña"
              },
              "phone": {
                "blank": "es obligatorio",
                "invalid": "%{attribute} no es valido"
              }
            }
          }
        }
      },
      "models": {
        "address": "Dirección",
        "invoice": "Factura",
        "order": "Orden",
        "payment_link": "Link de pago",
        "user": "Usuario"
      }
    },
    "admin": {
      "bank_transfer_payments": {
        "approve": "Approve Payment",
        "approved": "Payment approved successfully.",
        "reject": "Reject Payment",
        "rejected": "Payment rejected successfully.",
        "title": "Bank Transfer Payments",
        "view_title": "Payment Details"
      },
      "categories": {
        "create_button": "Create Category",
        "created": "Category created successfully.",
        "deleted": "Category deleted successfully.",
        "edit_title": "Edit Category",
        "new_title": "New Category",
        "seo_keywords_help": "SEO Keywords (comma separated).",
        "title": "Categories",
        "update_button": "Update Category",
        "updated": "Category updated successfully."
      },
      "coupons": {
        "archived": "Coupon archived successfully.",
        "create_button": "Create Coupon",
        "created": "Coupon created successfully.",
        "edit_title": "Edit Coupon",
        "new_title": "New Coupon",
        "restored": "Coupon restored successfully.",
        "title": "Coupons",
        "update_button": "Update Coupon",
        "updated": "Coupon updated successfully."
      },
      "dashboard": {
        "title": "Dashboard"
      },
      "experience_bookings": {
        "title": "Experience Bookings",
        "view_title": "Booking Details"
      },
      "experiences": {
        "archived": "Experience archived successfully.",
        "create_button": "Create Experience",
        "created": "Experience created successfully.",
        "edit_title": "Edit Experience",
        "new_title": "New Experience",
        "restored": "Experience restored successfully.",
        "title": "Experiences",
        "update_button": "Update Experience",
        "updated": "Experience updated successfully."
      },
      "orders": {
        "title": "Orders",
        "view_title": "Order Details"
      },
      "posts": {
        "archived": "Post archived successfully.",
        "create_button": "Create Post",
        "created": "Post created successfully.",
        "edit_title": "Edit Post",
        "new_title": "New Post",
        "restored": "Post restored successfully.",
        "title": "Posts",
        "update_button": "Update Post",
        "updated": "Post updated successfully."
      },
      "products": {
        "archive_product": "Archive Product",
        "archived": "Product archived successfully.",
        "basic_information": "Basic Information",
        "create_button": "Create Product",
        "created": "Product created successfully.",
        "description_help": "Full product description shown on product page",
        "edit_title": "Edit Product",
        "featured_position_help": "Set a position number to feature this product on the homepage.",
        "manage_variants": "Manage Variants",
        "media": "Media",
        "new_title": "New Product",
        "pricing_stock": "Pricing & Stock",
        "quick_actions": "Quick Actions",
        "restored": "Product restored successfully.",
        "seo": "SEO",
        "short_description_help": "Brief summary shown in product listings",
        "title": "Products",
        "update_button": "Update Product",
        "updated": "Product updated successfully.",
        "variants": "Variants",
        "view_on_store": "View on Store"
      },
      "registries": {
        "title": "Gift Registries",
        "view_title": "Registry Details"
      },
      "shared": {
        "actions": "Actions",
        "all": "All",
        "archive": "Archive",
        "cancel": "Cancel",
        "create": "Create",
        "created_at": "Created",
        "delete": "Delete",
        "edit": "Edit",
        "filter": "Filter",
        "restore": "Restore",
        "save": "Save",
        "search": "Search",
        "status": "Status",
        "translatable_content": "Translatable Content",
        "translatable_content_help": "Enter content in each language. English is required, Spanish is optional.",
        "update": "Update",
        "updated_at": "Updated",
        "view": "View"
      },
      "users": {
        "edit_title": "Edit User",
        "new_title": "New User",
        "title": "Users"
      }
    },
    "auth": {
      "already_have_account": "Already have an account?",
      "back": "Back",
      "back_to_home": "Back to home",
      "change_password": "Change your password",
      "confirm_new_password": "Confirm new password",
      "continue_with_email": "Continue with email",
      "create_account": "Create an account",
      "current_password": "Current password",
      "dont_have_account": "Don't have an account?",
      "email": "Email",
      "enter_email_address": "Enter your email address...",
      "errors_prohibited": "%{count} error(s) prohibited this user from being saved:",
      "forgot_password": "Forgot password?",
      "invalid_code": "Invalid or expired code",
      "log_out": "Log out",
      "new_password": "New password",
      "password": "Password",
      "password_confirmation": "Password confirmation",
      "password_minimum": "12 characters minimum.",
      "remember_me": "Remember me",
      "save_changes": "Save changes",
      "sign_in": "Sign In",
      "sign_in_without_password": "Sign in without password",
      "sign_out": "Sign Out",
      "sign_up": "Sign Up",
      "signed_in": "Signed in successfully",
      "signed_out": "Signed out successfully",
      "verification_sent": "We've sent the invitation to your email",
      "welcome": "Welcome! You have signed up successfully",
      "whats_your_email": "What's your email address?"
    },
    "breadcrumbs": {
      "blog": "Blog",
      "home": "Home",
      "store": "Store"
    },
    "cart": {
      "bank_transfer": "Bank Transfer",
      "cart_updated": "Cart updated",
      "checkout": "Checkout",
      "checkout_with_price": "Checkout - %{price}",
      "continue_shopping": "Continue shopping",
      "coupon": {
        "applied": "Coupon applied",
        "apply": "Apply",
        "invalid": "Invalid",
        "placeholder": "Enter code",
        "removed": "Coupon removed",
        "title": "Coupon Code"
      },
      "credit_debit_card": "Credit/Debit Card",
      "delivery_method": "Delivery method",
      "discount": "Discount",
      "discrete_delivery": "Discreet package delivery",
      "empty": "Your cart is empty",
      "empty_bag": "Your shopping bag is empty",
      "empty_message": "Add items to your cart to get started.",
      "estimated_total": "Estimated Total",
      "explore_collection": "Explore our collection",
      "item_removed": "Item removed",
      "items_in_bag": "Items in your Bag",
      "my_bag": "My Bag",
      "order_summary": "Order Summary",
      "payment_method": "Payment method",
      "paypal": "PayPal",
      "pickup": "Pick-up",
      "quantity": "Quantity",
      "related_products": "Related Products",
      "subtotal": "Subtotal",
      "title": "My Cart",
      "total": "Total"
    },
    "cart_items": {
      "color": "Color",
      "confirm_delete": "Sure you want to delete this item?",
      "gift_from": "Gift from %{registry_name}",
      "qty": "Qty",
      "recipient_wants": "Note: The recipient only wants %{quantity} of this item",
      "size": "Size",
      "unit": "Unit"
    },
    "categories": {
      "all_products": "All Products",
      "apply_filters": "Apply Filters",
      "browse_all": "Browse All Products",
      "clear_all": "Clear all",
      "colors": "Colors",
      "filter_by": "Filter By",
      "filter_by_colon": "Filter by:",
      "no_filters_available": "No filters available",
      "no_products": "No products in this category yet.",
      "our_pieces_of_art": "Our Pieces of Art",
      "shop_by_categories": "Shop by Categories",
      "shop_now": "Shop Now",
      "sizes": "Sizes",
      "sort": {
        "label": "Sort by",
        "newest": "Newest",
        "price_asc": "Price: Low to High",
        "price_desc": "Price: High to Low"
      },
      "title": "Store",
      "view_results": "View results (%{count})"
    },
    "checkout": {
      "billing_address": "Billing Address",
      "delivery_address": "Delivery Address",
      "delivery_fee": "Delivery fee",
      "different_address": "Use a different address",
      "discount": "Discount",
      "empty_bag": "Your shopping bag is empty",
      "explore_collection": "Explore our collection",
      "free": "Free",
      "items_in_bag": "Items in your Bag",
      "my_bag": "My Bag",
      "order_summary": "Order Summary",
      "payment_method": "Payment Method",
      "payment_method_disclaimer": {
        "bank_transfer": "<strong>By clicking \"Place Order\", you confirm that you are placing an order with an obligation to pay to Fancy Sinner via bank transfer.</strong><br><br>After confirming your order, we will show and/or email you our bank details and payment instructions. Your order will be processed once we confirm receipt of funds. By placing your order, you agree to <strong>Fancy Sinner's Terms of Sale</strong> and <strong>Privacy Policy</strong>, and you authorize us to use and share your personal data as necessary to manage your order and payment in accordance with those policies.",
        "paypal": "<strong>By clicking \"Place Order\" and continuing to PayPal, you confirm that you are making a purchase with an obligation to pay to Fancy Sinner.</strong><br><br>Your payment will be processed through <strong>PayPal</strong>. By completing your order, you agree to <strong>Fancy Sinner's Terms of Sale</strong> and <strong>Privacy Policy</strong>, and you acknowledge that PayPal will process your payment information in accordance with the <strong>PayPal User Agreement</strong> and <strong>PayPal Privacy Statement</strong>.",
        "stripe": "<strong>By clicking “Place Order”, you confirm that you are making a purchase with an obligation to pay to Fancy Sinner.</strong> <br> <br> Your payment will be processed securely by <strong>Stripe</strong> on our behalf. By completing your order, you agree to <strong><a href='%{terms}'>Fancy Sinner’s Terms of Sale</a></strong> and <strong><a href='%{privacy}'>Privacy Policy</a></strong>, and you acknowledge that your payment information will be handled by Stripe in accordance with the <strong>Stripe Services Agreement</strong> and <strong>Stripe Privacy Policy</strong>."
      },
      "pickup_address": "C/ Calle el Cayao #13. Piso 2, Serrallés. Distrito Nacional, Dominican Republic.",
      "pickup_at_store": "Pick-up at the store",
      "pickup_notification": "We will notify you when your order is available for pick-up.",
      "place_order": "Place Order",
      "processing": "Processing...",
      "same_as_billing": "Same as billing address",
      "shipping_address": "Shipping Address",
      "subtotal": "Subtotal",
      "title": "Checkout",
      "total": "Total"
    },
    "common": {
      "add_to_cart": "Add to Cart",
      "apply": "Apply",
      "back": "Back",
      "cancel": "Cancel",
      "continue_shopping": "Continue Shopping",
      "create": "Create",
      "delete": "Delete",
      "edit": "Edit",
      "loading": "Loading...",
      "next": "Next",
      "no_results": "No results found",
      "optional": "optional",
      "previous": "Previous",
      "proceed_to_checkout": "Proceed to Checkout",
      "proceed_to_payment": "Proceed to Payment",
      "remove": "Remove",
      "required": "required",
      "save": "Save",
      "start_shopping": "Start Shopping",
      "update": "Update",
      "view": "View",
      "view_details": "View Details"
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about 1 hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about 1 month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about 1 year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost 1 year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than 1 second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over 1 year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "1 day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "1 minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "1 month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "1 second",
          "other": "%{count} seconds"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      }
    },
    "errors": {
      "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "invalid_currency": "has invalid format (must be '100', '5%{decimal}24', or '123%{thousands}456%{decimal}78'). Got %{currency}",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is 1 character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is 1 character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be 1 character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "not_found": "Page not found",
      "something_went_wrong": "Something went wrong",
      "unacceptable_request": "A supported version is expected in the Accept header.\n",
      "unauthorized": "You are not authorized to view this page",
      "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
    },
    "experience_bookings": {
      "amount": "Amount",
      "booked_on": "Booked on",
      "booking_confirmed": "Booking Confirmed",
      "booking_date": "Booking Date",
      "booking_number": "Booking %{number}",
      "card": "Card",
      "confirmation": "Confirmation:",
      "confirmation_details": "Confirmation Details",
      "confirmation_number": "Confirmation Number",
      "duration": "Duration:",
      "experience": "Experience",
      "explore_experiences": "Explore Experiences",
      "no_bookings": "No experience bookings yet",
      "no_bookings_message": "When you book an experience, it will appear here.",
      "paid_via": "Paid via",
      "payment": "Payment",
      "status": "Status",
      "status_messages": {
        "cancelled": {
          "description": "If you have any questions about the cancellation, please contact us.",
          "title": "This booking has been cancelled"
        },
        "completed": {
          "description": "Thank you for joining us! We hope you had a wonderful time.",
          "title": "Experience completed"
        },
        "confirmed": {
          "description": "We look forward to seeing you. If you have any questions, please contact us.",
          "title": "Your experience is scheduled!"
        },
        "pending": {
          "description": "We'll be in touch soon to schedule your experience.",
          "title": "Payment received"
        },
        "processing": {
          "description": "We're working on scheduling your experience. Please check your email for updates.",
          "title": "We're in contact with you"
        }
      },
      "success": {
        "amount_paid": "Amount Paid",
        "booking_details": "Booking Details",
        "email_sent_html": "A confirmation email has been sent to <strong>%{email}</strong>",
        "max_group_size": "Max Group Size",
        "meta_title": "Booking Confirmed - %{name}",
        "next_step": "Next Step: Schedule Your Date",
        "people": {
          "one": "1 person",
          "other": "%{count} people"
        },
        "schedule_description": "Contact us via WhatsApp to pick your preferred date and time. We'll confirm availability and finalize your booking.",
        "schedule_on_whatsapp": "Schedule on WhatsApp",
        "thank_you_html": "Thank you for booking the <strong>%{name}</strong>",
        "title": "Booking Confirmed!",
        "whatsapp_message": "Hi! I just booked the %{name} and would like to schedule my session. My confirmation number is %{confirmation}."
      },
      "title": "My Experience Bookings",
      "total": "Total",
      "view_details": "View Details",
      "view_experience": "View Experience"
    },
    "experiences": {
      "book_now": "Book Now",
      "cta": {
        "description": "Secure your %{name} today and create unforgettable memories with your group.",
        "title": "Ready to Book?"
      },
      "duration": "Duration",
      "fancy_sinner_experiences": "Fancy Sinner Experiences",
      "faqs": "FAQs",
      "group_size": "Group Size",
      "how_to_book": {
        "step1_description": "Click \"Book Now\" and complete your payment securely online. You'll receive a confirmation immediately.",
        "step1_title": "Step 1: Book Online",
        "step2_description": "After booking, contact us on WhatsApp to pick your preferred date and time. We'll confirm availability.",
        "step2_title": "Step 2: Schedule via WhatsApp",
        "step3_description": "Arrive at our store and enjoy an unforgettable experience with your group. Everything is ready for you!",
        "step3_title": "Step 3: Enjoy the Experience",
        "title": "How To Book - Just 3 Easy Steps"
      },
      "no_experiences": "No experiences available",
      "other_experiences": "Other Experiences",
      "our_clients_say": "Our Clients Say",
      "policies": "Policies",
      "price": "Price",
      "reviews": "Reviews",
      "share": "Share",
      "time": "Time",
      "up_to_people": "Up to %{count} people",
      "whats_included": "What's Included",
      "why_choose": "Why choose %{name} at Fancy Sinner?"
    },
    "flash": {
      "admin": {
        "bank_transfer_payments": {
          "approval_failed": "Failed to approve payment: %{message}",
          "approved": "Payment approved and order #%{order_number} created.",
          "cart_already_paid": "Cannot approve: Cart already paid. Order %{order_number} exists.",
          "invalid_payment_type": "Invalid payment type",
          "rejected": "Payment rejected.",
          "rejection_reason_required": "Please provide a reason for rejection",
          "select_file": "Please select a file to upload",
          "voucher_upload_failed": "Failed to upload voucher",
          "voucher_uploaded": "Voucher uploaded successfully"
        },
        "bookings": {
          "status_updated": "Booking status updated to %{status}."
        },
        "categories": {
          "created": "Category created",
          "deleted": "Category removed",
          "updated": "Category updated"
        },
        "comparison_items": {
          "created": "Comparison item added.",
          "deleted": "Comparison item deleted.",
          "updated": "Comparison item updated."
        },
        "coupons": {
          "archived": "Coupon archived successfully.",
          "created": "Coupon created successfully.",
          "restored": "Coupon restored successfully.",
          "updated": "Coupon updated successfully."
        },
        "experiences": {
          "archived": "Experience archived successfully.",
          "created": "Experience created successfully.",
          "restored": "Experience restored successfully.",
          "updated": "Experience updated successfully."
        },
        "faqs": {
          "created": "FAQ added.",
          "deleted": "FAQ deleted.",
          "updated": "FAQ updated."
        },
        "orders": {
          "status_updated": "Order status updated to %{status}."
        },
        "posts": {
          "archived": "Post archived successfully.",
          "created": "Post created successfully.",
          "restored": "Post restored successfully.",
          "updated": "Post updated successfully."
        },
        "products": {
          "archived": "Product archived successfully.",
          "created": "Product created successfully.",
          "restored": "Product restored successfully.",
          "updated": "Product updated successfully."
        },
        "registries": {
          "updated": "Registry updated successfully."
        },
        "reviews": {
          "created": "Review added.",
          "deleted": "Review deleted.",
          "updated": "Review updated."
        },
        "users": {
          "updated": "User updated"
        },
        "variants": {
          "created": "Variant created successfully.",
          "deleted": "Variant deleted.",
          "updated": "Variant updated."
        }
      },
      "archived": "%{resource} archived successfully.",
      "auth": {
        "email_changed": "Your email has been changed",
        "email_verified": "Thank you for verifying your email address",
        "fill_email": "Fill your email address",
        "invalid_code": "Invalid or expired code",
        "invalid_credentials": "That email or password is incorrect",
        "invalid_reset_link": "That password reset link is invalid",
        "invalid_sign_in_link": "That sign in link is invalid",
        "invalid_verification_link": "That email verification link is invalid",
        "not_authorized": "Not authorized",
        "password_changed": "Your password has been changed",
        "password_reset_success": "Your password was reset successfully. Please sign in",
        "reset_instructions_sent": "Check your email for reset instructions",
        "session_logged_out": "That session has been logged out",
        "signed_in": "Signed in successfully",
        "signed_out": "Signed out successfully",
        "try_again_later": "Try again later",
        "verification_email_sent": "We sent a verification email to your email address",
        "verification_sent": "We've sent the invitation to your email %{email}.",
        "verify_email_first": "You can't reset your password until you verify your email",
        "welcome": "Welcome! You have signed up successfully"
      },
      "bookings": {
        "unable_to_process": "Unable to process booking. Please try again."
      },
      "cart": {
        "empty": "Your cart is empty",
        "invalid_quantity": "Invalid quantity",
        "item_removed": "Item removed",
        "items_added": "%{quantity} item(s) added to cart",
        "only_available": "Only %{quantity} available in stock",
        "option_out_of_stock": "Selected option is out of stock",
        "out_of_stock": "Out of stock",
        "quantity_unavailable": "Quantity unavailable in stock",
        "select_color": "Please select a color",
        "select_size": "Please select a size",
        "select_valid_option": "Please select a valid option",
        "updated": "Cart updated"
      },
      "checkout": {
        "fields_have_errors": "Some fields have errors"
      },
      "coupons": {
        "already_used": "You have already used this coupon",
        "applied": "Coupon applied successfully!",
        "cannot_apply": "This coupon cannot be applied",
        "expired": "This coupon has expired",
        "first_time_only": "This coupon is for first-time customers only",
        "inactive": "This coupon is inactive",
        "invalid": "Invalid coupon code",
        "minimum_required": "Minimum order of %{amount} required",
        "not_yet_valid": "This coupon is not yet valid",
        "removed": "Coupon removed",
        "usage_limit_reached": "This coupon has reached its usage limit"
      },
      "created": "%{resource} created successfully.",
      "deleted": "%{resource} deleted.",
      "invitations": {
        "sent": "An invitation email has been sent to %{email}"
      },
      "payments": {
        "bank_transfer": {
          "invalid_payment": "Invalid payment",
          "voucher_already_uploaded": "Voucher already uploaded",
          "voucher_required": "Please upload a voucher",
          "voucher_upload_failed": "Failed to upload voucher",
          "voucher_uploaded": "Voucher uploaded successfully. We will review your payment and notify you shortly."
        },
        "cancelled": "Payment cancelled",
        "capture_failed": "Payment capture failed: %{details}",
        "error": "Payment processing error",
        "invalid_session": "Invalid payment session",
        "not_approved": "Payment was not approved",
        "not_found": "Payment not found",
        "paypal": {
          "checkout_failed": "Failed to create PayPal checkout",
          "order_failed": "Failed to create PayPal order"
        },
        "stripe_error": "Payment error: %{message}",
        "success": "Payment successful! Your order has been confirmed."
      },
      "registry": {
        "already_purchased": "This item has already been purchased.",
        "created": "Registry created successfully.",
        "deleted": "Registry deleted.",
        "gift_added_to_cart": "Gift added to cart!",
        "item_added": "Added to your registry!",
        "item_removed": "Item removed from registry.",
        "item_updated": "Item updated.",
        "options_unavailable": "Selected options are not available.",
        "quantity_updated": "Updated quantity in your registry.",
        "select_color": "Please select a color before adding to registry.",
        "select_size": "Please select a size before adding to registry.",
        "updated": "Registry updated successfully."
      },
      "restored": "%{resource} restored successfully.",
      "subscriptions": {
        "pick_destination": "You need to pick the destination",
        "pick_frequency": "You need to pick a frequency",
        "pick_plan": "You need to pick a plan"
      },
      "updated": "%{resource} updated successfully."
    },
    "footer": {
      "about_us": "About Us",
      "addresses": "Addresses:",
      "categories": "Categories",
      "closed": "Closed",
      "contact": "Contact",
      "copyright": "Copyright - Fancy Sinner Lingerie",
      "experience": "Experience",
      "fancy_blog": "Fancy Blog",
      "faqs": "FAQ's",
      "mail": "Mail:",
      "monday_to_friday": "Monday to Friday:",
      "open": "Open:",
      "phone": "Phone:",
      "privacy_policy": "Privacy Policy",
      "return_policy": "Return Policy",
      "saturdays": "Saturdays:",
      "sunday": "Sunday:",
      "terms_and_conditions": "Terms And Conditions",
      "we_are": "We are"
    },
    "header": {
      "admin": "Admin",
      "cart": "Cart",
      "profile": "Profile",
      "search": "Search",
      "sign_in": "Sign In",
      "sign_up": "Sign Up"
    },
    "hello": "Hello world",
    "helpers": {
      "name": {
        "address": {
          "apartment": "Edificio / Apartamento / Extensión",
          "contact_name": "Nombre de contacto *",
          "door": "Número de puerta *",
          "name": "Alias *",
          "notes": "Referencias",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "sector": "Sector *",
          "shipping_zone_id": "Ciudad / Provincia *",
          "street": "Calle *"
        },
        "bucket": {
          "name": "Nombre",
          "plan": "Plan"
        },
        "discount": {
          "code": "Código (opcional)"
        },
        "order": {
          "user_id": "Cliente"
        },
        "payment_paypal": {
          "email": "Correo de PayPal"
        },
        "product": {
          "barcode": "Barcode",
          "discounted_price": "Precio con descuento",
          "featured_image": "Imagen destacada",
          "featured_image_alt": "Texto alterno de imagen destacada",
          "height_value": "Alto",
          "images": "Galería",
          "kind": "Tipo",
          "length_value": "Largo",
          "name": "Nombre",
          "package_barcode": "Barcode CAR",
          "price": "Precio",
          "sku": "SKU",
          "status": "Estado",
          "weight_value": "Peso",
          "width_value": "Ancho"
        },
        "user": {
          "company_name": "Nombre de la Empresa",
          "company_rnc": "RNC",
          "current_password": "Contraseña actual",
          "email": "Correo electrónico",
          "first_name": "Nombre",
          "has_whatsapp": "¿WhatsApp disponible?",
          "identification": "Identificación",
          "kind": "Tipo de usuario",
          "last_name": "Apellido",
          "password": "Contraseña",
          "password_confirmation": "Repetir contraseña",
          "phone": "Teléfono",
          "phone_mobile": "Teléfono móvil",
          "remember_me": "Permanecer conectado",
          "role": "Ról"
        }
      },
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "home": {
      "enter_email": "Enter your email...",
      "join_newsletter": "Join our newsletter",
      "join_now": "Join now",
      "newsletter_description": "Subscribe to Fancy Sinner and keep the surprises coming. Handmade, intimate, and just for you.",
      "subscribe": "Subscribe",
      "subscription_box": "Secret Subscription Box",
      "subscription_description": "Subscribe from $24.99/month to unlock handcrafted surprises every month."
    },
    "js": {
      "checkout": {
        "free": "Free"
      },
      "confirm": {
        "cancel": "Cancel",
        "ok": "OK",
        "title": "Are you sure?"
      },
      "dropzone": {
        "cancel_upload": "Cancel upload",
        "cancel_upload_confirmation": "Are you sure you want to cancel this upload?",
        "default_message": "Drop files here to upload",
        "fallback_message": "Your browser does not support drag and drop file uploads.",
        "fallback_text": "Please use the fallback form below to upload your files.",
        "file_too_big": "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
        "file_too_large": "\"%{filename}\" exceeds the maximum file size of %{max_size}MB.",
        "invalid_file_type": "You can't upload files of this type.",
        "invalid_image": "\"%{filename}\" is not a valid image file.",
        "invalid_type_image_pdf": "This file type is not allowed. Please upload an image or PDF.",
        "max_files_exceeded": "You can not upload any more files.",
        "only_one_file": "Only one file can be uploaded.",
        "remove": "Remove",
        "remove_file": "Remove file",
        "response_error": "Server responded with {{statusCode}} code.",
        "select_file_first": "Please select a file first",
        "upload_failed": "Upload failed",
        "upload_failed_retry": "Upload failed. Please try again."
      },
      "error": "An error occurred",
      "file_size": {
        "bytes": "Bytes",
        "gb": "GB",
        "kb": "KB",
        "mb": "MB",
        "zero_bytes": "0 Bytes"
      },
      "loading": "Loading...",
      "product": {
        "added_to_cart": "Added to cart",
        "option_not_available": "Option not available",
        "out_of_stock": "Out of stock",
        "quantity_updated": "Quantity updated",
        "select_options": "Please select all options"
      },
      "success": "Success"
    },
    "landing": {
      "banner": {
        "cta": "Own the night",
        "description": "Every month, for just $24.99, a handcrafted piece of temptation arrives at your door — ready to elevate your nights.",
        "title": "The Fancy Never Stops"
      },
      "categories": {
        "shop_now": "Shop Now",
        "title": "Categories"
      },
      "featured_in": {
        "title": "Featured In"
      },
      "hero": {
        "cta_button": "Make it yours",
        "description": "Handcrafted lingerie in the Dominican Republic and delivered monthly to make every moment unforgettable.",
        "email_placeholder": "Your email for fancier nights…",
        "privacy_note": "We never share your secrets. Or your email. What happens while wearing us stays between us.",
        "social_proof": "7347 women already keeping it fancy every month.",
        "title_line1": "Elevate your nights,",
        "title_line2": "one fancy piece at a time"
      },
      "how_it_works": {
        "step1_description": "fill out a short form with your likes, dislikes, and boundaries. We want to know exactly what turns you on—or off.",
        "step1_title": "Step 1: Tell us What you like",
        "step2_description": "Start with one subscription for one surprise piece each month. Want the full set? Some of our clients, like in Little Mac, go for two active subscriptions to get the complete fantasy.",
        "step2_title": "Step 2: Choose your subscription",
        "step3_description": "Every month, you'll receive lingerie made just for your taste. No random picks—just intimate pieces that match your vibe and make you feel amazing.",
        "step3_title": "Step 3: Enjoy what you actually Like",
        "title": "How Fancy Sinner Works – Just 3 Easy Steps"
      },
      "newsletter": {
        "cta": "Join now",
        "description": "Subscribe to Fancy Sinner and keep the surprises coming. Handmade, intimate, and just for you.",
        "title": "Join our newsletter"
      },
      "our_pieces": {
        "shop_now": "Shop Now",
        "title": "Our Pieces of Art"
      },
      "subscriptions": {
        "claim": "Claim",
        "one_piece": {
          "description": "A single handcrafted lingerie piece, selected just for you. A sensual surprise to elevate your nights.",
          "name": "One Piece Fantasy",
          "price": "$24.99"
        },
        "title": "Subscriptions",
        "two_piece": {
          "description": "A complete two-piece set, perfectly matched to double the elegance — and the temptation.",
          "name": "Double the Temptation",
          "price": "$49.99"
        }
      },
      "testimonials": {
        "title": "Our Client Says"
      }
    },
    "mailers": {
      "common": {
        "greeting": "Hi %{name},",
        "greeting_default": "Hi there,",
        "help_text": "Have questions or need help? Just reply to this email and our support team will help you sort it out.",
        "team_signature": "- The Fancy Sinner Team",
        "thank_you": "Thank you for shopping with Fancy Sinner!"
      },
      "experience_booking_mailer": {
        "confirmation": {
          "amount_paid": "Amount Paid",
          "confirmation_number": "Confirmation Number",
          "copyright": "© %{year} Fancy Sinner. All rights reserved.",
          "duration": "Duration",
          "experience": "Experience",
          "intro": "Thank you for booking the <strong>%{experience_name}</strong>! We're excited to host you and your group.",
          "max_group_size": "Max Group Size",
          "next_step": "Next Step: Schedule Your Date",
          "people": "%{count} people",
          "questions": "If you have any questions, feel free to reach out to us.",
          "schedule_button": "Schedule on WhatsApp",
          "schedule_notice": "Contact us via WhatsApp to pick your preferred date and time. We'll confirm availability and finalize the details.",
          "see_you_soon": "See you soon!",
          "subject": "Booking Confirmed - %{experience_name}",
          "title": "Your Booking is Confirmed!",
          "whatsapp_message": "Hi! I just booked the %{experience_name} and would like to schedule my session. My confirmation number is %{confirmation_number}."
        }
      },
      "order_mailer": {
        "bank_transfer_pending_review": {
          "bank_transfer": "Bank Transfer",
          "delivery_fee": "Delivery Fee:",
          "discount": "Discount",
          "intro": "We've received your payment voucher and our team is now reviewing it.",
          "payment_details": "Payment Details",
          "payment_method": "Payment Method:",
          "questions": "If you have any questions, please don't hesitate to contact us.",
          "review_notice": "Our team will verify your payment within 1-2 business days. Once verified, you'll receive a confirmation email with your order details.",
          "subject": "Payment Received - Under Review",
          "submitted": "Submitted:",
          "subtotal": "Subtotal:",
          "title": "Payment Received - Under Review",
          "total": "Total:",
          "whats_next": "What's Next?"
        },
        "bank_transfer_rejected": {
          "alternative": "You can also try placing a new order with an alternative payment method.",
          "amount": "Amount:",
          "apology": "We apologize for any inconvenience.",
          "error_notice": "If you believe this was an error, please contact us with your transfer details and we'll be happy to investigate further.",
          "intro": "Unfortunately, we were unable to verify your bank transfer payment.",
          "payment_details": "Payment Details",
          "reason": "Reason",
          "subject": "Payment Could Not Be Verified",
          "submitted": "Submitted:",
          "title": "Payment Could Not Be Verified",
          "verify_account": "The transfer was made to the correct bank account",
          "verify_amount": "The correct amount was transferred",
          "verify_instructions": "Please verify that:",
          "verify_voucher": "The voucher/receipt image was clear and readable",
          "what_can_you_do": "What Can You Do?"
        },
        "order_confirmed": {
          "delivery_fee": "Delivery Fee:",
          "discount": "Discount",
          "intro": "We're excited to confirm that your order has been received and is being processed.",
          "items": "Items",
          "order_date": "Order Date:",
          "order_details": "Order Details",
          "order_number": "Order Number:",
          "payment_method": "Payment Method:",
          "phone": "Phone:",
          "shipping_address": "Shipping Address",
          "shipping_notice": "We'll send you another email when your order ships.",
          "subject": "Order Confirmed - %{order_number}",
          "subtotal": "Subtotal:",
          "title": "Thank you for your order!",
          "total": "Total:"
        }
      },
      "registry_mailer": {
        "gift_received": {
          "gift_details": "Gift Details",
          "intro": "Someone just purchased a gift from your <strong>%{registry_name}</strong> registry!",
          "progress": "Your registry now has %{fulfilled} of %{total} items purchased.",
          "quantity": "Quantity:",
          "subject": "Someone purchased a gift from your registry!",
          "thank_you": "Thank you for using Fancy Sinner!",
          "title": "Great news!",
          "view_registry": "View Your Registry"
        }
      },
      "user_mailer": {
        "email_verification": {
          "action_required": "You must hit the link below to confirm that you received this email.",
          "greeting": "Hey there,",
          "intro": "This is to confirm that %{email} is the email you want to use on your account. If you ever lose your password, that's where we'll email a reset link.",
          "link_text": "Yes, use this email for my account",
          "subject": "Verify your email"
        },
        "invitation_instructions": {
          "greeting": "Hey there,",
          "ignore_notice": "If you don't want to accept the invitation, please ignore this email. Your account won't be created until you access the link above and set your password.",
          "intro": "Someone has invited you to the application, you can accept it through the link below.",
          "link_text": "Accept invitation",
          "subject": "Invitation instructions"
        },
        "password_reset": {
          "greeting": "Hey there,",
          "ignore_notice": "If you did not request a password reset you can safely ignore this email, it expires in 20 minutes. Only someone with access to this email account can reset your password.",
          "intro": "Can't remember your password for <strong>%{email}</strong>? That's OK, it happens. Just hit the link below to set a new one.",
          "link_text": "Reset my password",
          "subject": "Reset your password"
        },
        "passwordless": {
          "code_valid_notice": "This code will only be valid for the next 60 minutes:",
          "link_valid_notice": "This link and code will only be valid for the next 60 minutes. If the link does not work, you can use the login verification code directly:",
          "login_button": "Login to Fancy Sinner",
          "subject": "Login to Fancy Sinner",
          "title": "Your login code for Fancy Sinner"
        }
      }
    },
    "masquerade": {
      "exit": "Exit",
      "session_as": "Session as %{name}",
      "signed_in": "Signed in successfully",
      "signed_out": "Signed out successfully"
    },
    "nav": {
      "all_products": "All Products",
      "experiences": "Experiences",
      "how_it_works": "How It Works",
      "no_categories_available": "No categories available",
      "no_experiences_available": "No experiences available",
      "our_pieces_of_art": "Our Pieces of Art",
      "store": "Store",
      "subscriptions": "Subscriptions"
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "orders": {
      "billing_address": "Billing Address",
      "delivery_fee": "Delivery Fee",
      "discount": "Discount",
      "gift_from": "Gift from %{registry_name}",
      "items": "Items",
      "more_items": "+%{count} more",
      "no_orders": "No orders yet",
      "no_orders_message": "When you place an order, it will appear here.",
      "order": "Order",
      "order_date": "Order Date",
      "order_number": "Order %{number}",
      "order_on_way": "It's on its way to you.",
      "order_picked_up": "Order picked up.",
      "order_placed_on": "Order placed on",
      "order_received": "Order received.",
      "order_received_notice": "We'll start preparing your order shortly.",
      "order_shipped": "Your order has been shipped!",
      "paid_via": "Paid via",
      "payment": "Payment",
      "phone": "Phone",
      "pickup_location": "Pickup Location",
      "pickup_ready": "Your order is ready for pickup!",
      "pickup_ready_notice": "Please bring a valid ID when collecting your order.",
      "preparing_notice": "We'll notify you when it's ready for pickup.",
      "preparing_order": "We're preparing your order.",
      "preparing_shipment": "We're preparing your order for shipment.",
      "qty": "Qty",
      "shipping_address": "Shipping Address",
      "start_shopping": "Start Shopping",
      "status": "Status",
      "store_name": "Fancy Sinner Store",
      "subtotal": "Subtotal",
      "thank_you": "Thank you for shopping with us!",
      "title": "My Orders",
      "total": "Total",
      "view_details": "View Details"
    },
    "payments": {
      "bank_transfer": {
        "pending_review": "Payment pending review",
        "return_to_cart": "Return to Cart",
        "title": "Bank Transfer",
        "upload_voucher": "Upload Voucher",
        "view_order": "View Order",
        "voucher_already_uploaded": "Voucher already uploaded",
        "voucher_required": "Please upload a voucher",
        "voucher_uploaded": "Voucher uploaded successfully"
      }
    },
    "posts": {
      "no_posts": "No posts yet",
      "no_posts_message": "Check back soon for new articles!",
      "published_on": "Published on %{date}",
      "read_more": "Read More",
      "title": "Fancy Blog"
    },
    "products": {
      "add_to_cart": "Add to Cart",
      "add_to_registry": "Add to Registry",
      "additional_info": "Additional information",
      "color": "Color:",
      "create_new_registry": "+ Create New Registry",
      "create_registry": "Create a Registry",
      "delivery_info": "Delivery in 1-3 business days, 7-14 to the U.S.",
      "from_price": "From %{price}",
      "in_stock": "In Stock",
      "made_to_order": "Made to Order",
      "made_with_love": "Made with love in Dominican Republic",
      "material": "Material",
      "model_wearing": "Model is wearing \"%{size}\".",
      "out_of_stock": "Out of Stock",
      "pick_color": "Pick a color:",
      "pick_size": "Pick a size:",
      "pick_your_size": "Pick your size",
      "product_spec": "Product Spec",
      "related_products": "Related Products",
      "return_policies": "Return policies",
      "select_color": "Select Color",
      "select_size": "Select Size",
      "size": "Size:"
    },
    "profiles": {
      "build_again": "Build it again",
      "build_description": "Save your sizes, preferences, and details to shop faster and smarter. A complete profile means a smoother checkout and a shopping experience made just for you.",
      "build_your_profile": "Build your profile",
      "complete_your_profile": "Complete your profile",
      "fields": {
        "belly_size": "Belly size:",
        "bottom_size": "Bottom size:",
        "bottoms_preference": "Bottoms preference:",
        "bra_size": "Bra size:",
        "excluded_colors": "Excluded colors:",
        "favorite_colors": "Favorite colors:",
        "occasion_preference": "Occasion preference:",
        "packaging": "Packaging:",
        "prints_preference": "Prints preference:",
        "sexy_rating": "Sexy rating:",
        "thongs_rating": "Thongs rating:"
      },
      "sections": {
        "delivery": "Delivery",
        "fit": "Fit",
        "preferences": "Preferences"
      },
      "sidebar": {
        "experience_bookings": "Experience Bookings",
        "free": "Free - ",
        "gift_registry": "Gift Registry",
        "manage_subscription": "Manage Subscription",
        "orders": "Orders",
        "profile_overview": "Profile Overview",
        "your_information": "Your Information"
      },
      "title": "Profile Overview"
    },
    "registries": {
      "add_gift_to_cart": "Add Gift to Cart",
      "add_items": {
        "browse": "Browse Products",
        "description": "Browse our collection and add items you'd love to receive.",
        "title": "Add Items to Your Registry"
      },
      "anonymous": "Anonymous",
      "create_first": "Create Your First Registry",
      "create_new": "Create Registry",
      "create_title": "Create Gift Registry",
      "created": "Registry created successfully.",
      "days_away": {
        "one": "1 day away",
        "other": "%{count} days away"
      },
      "delete_confirm": "Are you sure you want to delete this registry? This cannot be undone.",
      "delete_registry": "Delete Registry",
      "deleted": "Registry deleted.",
      "edit_heading": "Edit Registry",
      "edit_title": "Edit %{name}",
      "event_passed": "Event passed",
      "event_today": "Today!",
      "event_types": {
        "anniversary": "Anniversary",
        "baby_shower": "Baby Shower",
        "birthday": "Birthday",
        "graduation": "Graduation",
        "housewarming": "Housewarming",
        "other": "Other",
        "wedding": "Wedding"
      },
      "form": {
        "create": "Create Registry",
        "event_date_hint": "Optional - the date of your special occasion",
        "fix_errors": "Please fix the following errors:",
        "name_placeholder": "e.g., Our Wedding Registry",
        "select_occasion": "Select occasion...",
        "update": "Update Registry"
      },
      "from": "From:",
      "gifts_count": {
        "one": "1 gift",
        "other": "%{count} gifts"
      },
      "gifts_received": "Gifts Received",
      "items_count": {
        "one": "1 item",
        "other": "%{count} items"
      },
      "no_items": "No items in your registry yet.",
      "no_items_hint": "Browse our collection to add items.",
      "no_registries": "No registries yet",
      "no_registries_message": "Create a gift registry for your special occasion.",
      "partial_purchased": "%{purchased}/%{total} purchased",
      "priority": "Priority",
      "purchased": "Purchased",
      "purchased_count": {
        "one": "1 purchased",
        "other": "%{count} purchased"
      },
      "qty": "Qty:",
      "registry_items": "Registry Items",
      "remove_confirm": "Remove this item from your registry?",
      "share": {
        "copied": "Copied!",
        "copy": "Copy",
        "description": "Send this link to friends and family:",
        "title": "Share your registry"
      },
      "title": "My Gift Registries",
      "updated": "Registry updated successfully.",
      "visibility": {
        "hidden": "Private",
        "link_only": "Link Only",
        "public_visible": "Public"
      },
      "visibility_options": {
        "hidden": "Private - Only you can see",
        "link_only": "Link Only - Anyone with the link can view",
        "public_visible": "Public - Visible to everyone"
      }
    },
    "search": {
      "no_results": "No products found",
      "placeholder": "Search products...",
      "title": "Search",
      "try_different": "Try a different search term"
    },
    "subscriptions": {
      "claim": "Claim",
      "continue": "Continue",
      "delivery": {
        "do_description": "Delivered in about 5 business days — handcrafted locally, fast to your door.",
        "dominican_republic": "Dominican Republic",
        "title": "Tell us where to deliver your Fancy Box",
        "united_states": "United States",
        "us_description": "Delivered in 7–14 business days — with an extra touch of care."
      },
      "fancy_secret": "Fancy Secret Subscription",
      "faqs": {
        "q1_answer": "Each month, you'll receive a handcrafted lingerie piece (or set, depending on your plan), carefully selected to surprise and elevate your intimate moments. Every box is unique, sensual, and made with love in the Dominican Republic.",
        "q1_question": "What's included in my Fancy Secret Subscription Box?",
        "q2_answer": "Absolutely. You're always in control — you can pause, skip a month, or cancel anytime from your account dashboard. No questions asked.",
        "q2_question": "Can I pause or cancel my subscription?",
        "q3_answer": "We process and ship your first box within 3–5 business days after your order. Delivery takes about 5 business days in the Dominican Republic and 10–14 business days in the United States.",
        "q3_question": "When will I receive my first box?",
        "q4_answer": "We curate each box based on your selected plan and our current collection of handcrafted lingerie. We aim to surprise you with pieces that feel bold, elegant, and unforgettable.",
        "q4_question": "How do you choose the pieces I get?",
        "q5_answer": "Yes — all our boxes are shipped in plain, discreet packaging to keep your surprise private until you open it.",
        "q5_question": "Do you offer discreet packaging?",
        "title": "Frequently asked questions"
      },
      "featured_in": "Featured In",
      "frequency": {
        "monthly": "Monthly",
        "monthly_description": "Billed every month — flexibility to pause or cancel anytime.",
        "yearly": "Yearly",
        "yearly_one_piece_annual": "$269.99 billed annually — <span class=\"font-bold text-accent-red\">save $30 and commit to a year of temptation.</span>",
        "yearly_two_piece_annual": "$539.99 billed annually — <span class=\"font-bold text-accent-red\">save $30 and commit to a year of temptation.</span>"
      },
      "invitation": {
        "email_address": "Email Address",
        "email_placeholder": "Your email for fancier nights…",
        "enter_your": "Enter your",
        "hero_description": "Handcrafted lingerie in the Dominican Republic and delivered monthly to make every night unforgettable.",
        "hero_title_line1": "Elevate your nights,",
        "hero_title_line2": "one fancy piece at a time",
        "make_it_yours": "Make it yours",
        "privacy_note": "We never share your secrets. Or your email. What happens while wearing us stays between us.",
        "social_proof": "7347 women already keeping it fancy every month."
      },
      "invitation_sent": {
        "message": "We've sent your invitation. Please check your inbox.",
        "no_email": "No email yet?",
        "title": "Invitation sent",
        "try_again": "Try again"
      },
      "must_pick_frequency": "You need to pick a frequency",
      "must_pick_plan": "You need to pick a plan",
      "pick_frequency": "Pick a frequency",
      "pick_plan": "Pick a plan",
      "plans": {
        "one_piece": {
          "description": "A single handcrafted lingerie piece, selected just for you. A sensual surprise to elevate your nights.",
          "name": "One Piece Fantasy",
          "price": "$24.99"
        },
        "two_piece": {
          "description": "A complete two-piece set, perfectly matched to double the elegance — and the temptation.",
          "name": "Double the Temptation",
          "price": "$49.99"
        }
      },
      "press": {
        "listin_diario": "Laura Peña revolucionó la pasarela de DominicanaModa con su colección \"The Jaguar\"",
        "nacional": "<b>Una apuesta por la moda dominicana</b>, selección criolla apoyará a diseñadores y proyectos emprendimientos",
        "nuevo_diario": "\"El glamour y la sensualidad de fancy Sinner Lingirie se lucen en <b>Dominicana Moda</b>\"",
        "pandora": "Laura Peña nos sumerge en el universo de Fancy Sinner"
      },
      "select_your": "Select your",
      "title": "Subscriptions",
      "your_way": "Your subscription, your way:"
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  }
}
